module.exports = __webpack_public_path__ + "static/ThePioneers_2226x1000-3ccac98bd78117a9fa94342d79ca3ce3.png";